// NPO Card icons
export const heartFill = require('./heart_fill.png');
export const heartEmpty = require('./heart_empty.png');

// NPO Home icons
export const filterIcon = require('./filter.png');

//OnBoarding
export const npoIcon = require('./npo.png');
// LightRating
export const candleIcon = require('./candle.png');

// mix
export const checkIcon = require('./check.png');
export const warningIcon = require('./warning.png');
export const backIcon = require('./back.png');
export const pencilIcon = require('./pencil.png');
export const infoIcon = require('./info.png');
export const verifiedIcon = require('./verified_icon.png');
export const homeFillIcon = require('./home.png');
export const userFill = require('./user-fill.png');

// Nav Tabs
export const homeIcon = require('./nav_tabs/home_icon.png');
export const donationIcon = require('./nav_tabs/donation_icon.png');
export const engageIcon = require('./nav_tabs/engage_icon.png');
export const impactIcon = require('./nav_tabs/impact_icon.png');
export const profileIcon = require('./nav_tabs/profile_icon.png');
export const transactionsIcon = require('./nav_tabs/transaction_icon.png');

// Programs
export const programDefaultIcon = require('./program_default.png');

// Custom Markers
export const radioMarker = require('./radio_marker.png');

//Donate
export const donateIcon = require('./donate.png');
export const cardIcon = require('./card_icon.png');

//Profile
export const profilePlaceholder = require('./profile_placeholder.png');

// Claim
export const claimIcon = require('./claim_icon.png');
